import { EMPTY_GUID, DEFAULT_DEBOUNCE_TIME, TABLE_VIEW_MODES } from './constants/commonConstants';
import { GlobalService } from './services/global.service';

export const isNotEmpty = (value: any) => {
  return (
    value !== undefined && value !== null && value !== '' && value !== EMPTY_GUID && JSON.stringify(value) !== '{}'
  );
};

export const isNumber = (value: any) => {
  return !isNaN(parseFloat(value)) && !isNaN(value - 0);
};

export const isValidGuid = (value: string) => {
  return /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/.test(value);
};

export const hasOnlyDigits = (value: string) => {
  if (/^\d+$/.test(value)) {
    return true;
  }

  return false;
};

export const isValidEmail = (value: string) => {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(value).toLowerCase());
};

export const debounce = (func, timeout = DEFAULT_DEBOUNCE_TIME) => {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(this, args);
    }, timeout);
  };
};

export function scrollTop() {
  window.scroll({ top: 0, left: 0, behavior: 'smooth' });
}

export function currentTimezoneDateTime(currentTimezoneDate: Date | null = null): string {
  const currentDate = currentTimezoneDate ?? new Date();
  const offsetTime = -60000;
  const currentDateWithOffset = currentDate.getTime() + currentDate.getTimezoneOffset() * offsetTime;

  return new Date(currentDateWithOffset).toISOString();
}

export function normalizeString(value: string) {
  return value
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();
}

export function isSafari(): boolean {
  return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
}

export function setTableViewMode(
  globalService: GlobalService,
  route: string,
  defaultViewListMode: string = TABLE_VIEW_MODES.LIST_VIEW
) {
  let tableViewMode = defaultViewListMode;
  const mappedRoute = Object.keys(globalService.viewModesMap).find(routeKey => route.includes(routeKey));
  if (mappedRoute) {
    tableViewMode = globalService.viewModesMap[mappedRoute];
  }

  return tableViewMode;
}

export function uriNormalize(uri: string): string {
  return uri.endsWith('/') ? uri.slice(0, -1) : uri;
}

export function convertFileSize(size: number): string {
  if (size < 1024) {
    return `${size} B`;
  } else if (size < 1024 * 1024) {
    return `${(size / 1024).toFixed(2)} KB`;
  } else {
    return `${(size / (1024 * 1024)).toFixed(2)} MB`;
  }
}

export function deepMerge(target: any, source: any): any {
  const output = { ...target };

  if (isObject(target) && isObject(source)) {
    Object.keys(source).forEach(key => {
      if (isObject(source[key])) {
        if (!(key in target)) {
          Object.assign(output, { [key]: source[key] });
        } else {
          output[key] = deepMerge(target[key], source[key]);
        }
      } else {
        if (source[key] !== '') {
          Object.assign(output, { [key]: source[key] });
        }
      }
    });
  }

  return output;
}

export function isObject(item: any): boolean {
  return item && typeof item === 'object' && !Array.isArray(item);
}
